import LegalPage from "@/pages/legal/LegalPage";

export default function ManagementPolicy() {
  return (
    <LegalPage title="Yönetim Sistemleri Politikası" testId="legal-management">
      <div className="rounded-2xl border border-zinc-200 bg-[#faf9ff] p-7">
        <h2 className="font-display text-lg font-bold text-[#101436]">Bilgi Güvenliği Yönetim Sistemi Politikası</h2>
        <p className="mt-3">
          ENTA-NET TELEKOMÜNİKASYON VE BİLGİ TEKNOLOJİLERİ TİCARET LİMİTED ŞİRKETİ olarak,
          faaliyet gösterdiğimiz internet servis sağlayıcılığı ve elektronik haberleşme sektöründe
          bilgi güvenliğini en üst seviyede sağlayarak, ülkemizin siber güvenlik kapasitesinin
          güçlendirilmesine katkı sunmayı ve kritik bilgi altyapılarının korunmasını temel
          önceliklerimiz arasında görmekteyiz. Bu doğrultuda, bilgi varlıklarının korunması, siber
          tehditlere karşı dayanıklılığın artırılması ve güvenli hizmet sunumu için sürekli iyileştirme
          yaklaşımını benimsiyoruz.
        </p>
        <p className="mt-3">
          Kuruluşumuzda işletmekte olduğumuz Bilgi Güvenliği Yönetim Sistemi, kablolu ve kablosuz
          elektronik haberleşme altyapıları üzerinden internet erişim hizmetlerinin sunulması,
          işletilmesi ve yönetilmesi faaliyetlerini ve Saray Mah. 106_1 Sok. No:12A Silifke, Mersin
          adresinde yürütülen tüm iş süreçlerini, çalışanları, bilgi sistemlerini ve üçüncü taraf
          ilişkilerini kapsar.
        </p>
      </div>

      <h2 className="font-display text-lg font-bold text-[#101436]">Bilgi Güvenliği İlkelerimiz</h2>
      <ul className="list-disc space-y-2 ps-6">
        <li>
          Bilgi güvenliği; şirketimize ait tüm bilgi varlıklarının gizlilik, bütünlük ve
          erişilebilirliğinin korunması ve buna bağlı risklerin yönetilmesini ifade eder.
        </li>
        <li>
          Bilgi varlıklarımızın gizlilik sınıfını; kritiklik derecesi, yasal gereksinimler ve verinin
          hassasiyeti kriterlerine göre; Çok Gizli, Gizli, Hizmete Özel, Kurumsal ve Tasnif Dışı
          olarak tanımlar ve uygun koruma seviyelerini sağlarız.
        </li>
        <li>
          Bilgi güvenliği risklerini sistematik bir yaklaşımla varlık ve süreç bazlı olarak tanımlar,
          analiz eder ve kabul edilebilir seviyeye indirmek için gerekli aksiyonları alırız.
        </li>
        <li>
          Uygulamakta olduğumuz bilgi güvenliği politika, prosedür, kural, prensip ve standartlarını
          tüm organizasyona yaygınlaştırır ve etkinliğini düzenli olarak gözden geçiririz.
        </li>
      </ul>

      <h2 className="font-display text-lg font-bold text-[#101436]">Taahhütlerimiz</h2>
      <p>
        Bu vizyonumuzu gerçekleştirirken ENTA-NET TELEKOMÜNİKASYON VE BİLGİ TEKNOLOJİLERİ TİCARET
        LİMİTED ŞİRKETİ olarak hizmetlerimizi ulusal ve uluslararası standartlara uygun olarak sunmak
        adına:
      </p>
      <ul className="list-disc space-y-2 ps-6">
        <li>ISO 27001 Bilgi Güvenliği Yönetim Sistemi standartlarını benimsemekte, işletmekte ve sürekli geliştirmeyi</li>
        <li>Yönetim olarak bilgi güvenliği hedeflerinin gerçekleştirilmesi için gerekli tüm kaynakları sağlamayı ve faaliyetleri desteklemeyi</li>
        <li>İç ve dış müşterilerimize sunduğumuz hizmetlerin güvenli, kesintisiz ve sürdürülebilir şekilde sunulmasını sağlamayı</li>
        <li>Müşteri memnuniyetini artırmayı</li>
        <li>Çalışanlarımızın bilgi güvenliği farkındalığını artırmayı ve gelişimlerini sürekli desteklemeyi</li>
        <li>Uygulamakta olduğumuz yönetim sistemlerini sürekli iyileştirmeyi</li>
        <li>Tabi olduğumuz ulusal ve uluslararası mevzuatlar ve diğer uygulanabilir şartlara uyum sağlamayı</li>
      </ul>
      <p className="font-bold text-[#101436]">taahhüt ederiz.</p>
    </LegalPage>
  );
}
